import { BaseResource } from 'utils/ApiUtils';

export default class Visitor extends BaseResource {
  static columns = [
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection"
    },
    { title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Visit Date",
      field: "visitDate",
      type: "date",
      defaultSort: "desc"
    },
    {
      title: "Name",
      field: "name"
    },
    {
      title: "Title",
      field: "title"
    },
    {
      title: "Company",
      field: "company"
    },
    {
      title: "Purpose",
      field: "purpose"
    },
    {
      title: "Time In",
      field: "timeIn",
      type: "datetime"
    },
    {
      title: "Time Out",
      field: "timeOut",
      type: "datetime"
    }
  ];

  static attributes = Visitor.columns.map((r) => r.field);

  static expand = [
    {
      "Ihwi": {
        expand: [
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    }
  ];

  constructor(args) {
    super(args, Visitor.attributes);
  }
}
